import React, { useEffect, useState, redux } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./notification.css";
import { formatDistanceToNow } from "date-fns";
import uiActions from "../../../redux/ui/action";
import LoaderPopUp from "../../../components/loader/loader";

function Notification(props) {
  const { loader, startLoading, finishLoading } = props;

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      startLoading(); 

      const today = new Date();
      const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
      const startDate = sevenDaysAgo.toISOString().split("T")[0];
      const endDate = today.toISOString().split("T")[0];

      try {
        const response = await axios.post(
          "https://bg.mescray001.com/api/v1/attendance-service/get-user-noti-datewise",
          {
            startDate,
            endDate,
            rollNo: "25017005141",
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        setNotifications(response.data.data || []);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        finishLoading(); 
      }
    };

    fetchNotifications();
  }, [startLoading, finishLoading]);

  return (
    <div className="notification-wrapper">
      <div className="notification-triangle"></div>
      <div className="notification-card">
        <div className="notification-header">
          <div className="notification-title-text">Notifications</div>
          <Link to="/overviewNotification" className="notification-view-all">
            View all &gt;
          </Link>
        </div>

        {loader ? (
          <LoaderPopUp />
        ) : notifications.length > 0 ? (
          notifications.map((item) =>
            item.notification_description ? (
              <div key={item.notification_id} className="notification-item">
                <div className="notification-logo">Motion</div>
                <div className="notification-content">
                  <p className="notification-text">
                    {item.notification_description}
                  </p>
                  <p className="notification-time">
                    {item.created_at
                      ? formatDistanceToNow(new Date(item.created_at), {
                          addSuffix: true,
                        })
                      : "No date"}
                  </p>
                </div>
              </div>
            ) : null
          )
        ) : (
          <p>No notifications found.</p>
        )}
      </div>
    </div>
  );
}


const mapStateToProps = (state) => ({
  loader: state.ui.loader, 
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
